"use client";

import { useScrollHeader } from "@/hooks/useScrollHeader";
import { ComponentProps, FC } from "react";
import { X } from "react-feather";

type ICloseBannerButtonProps = ComponentProps<"button">;

const CloseBannerButton: FC<ICloseBannerButtonProps> = (props) => {
  const { isAnchorVisible, setIsAnchorVisible } = useScrollHeader({
    anchorElementId: "global-banner",
    headerSelector: "header",
    scrollBufferPx: 500,
    throttleDelayMs: 100,
  });

  return (
    <button
      onClick={() => setIsAnchorVisible(false)}
      data-visible={isAnchorVisible}
      className="absolute right-2 top-2 rounded-full p-2 transition hover:bg-primary-950"
      aria-label="Close banner"
    >
      <X size={20} />
    </button>
  );
};

export default CloseBannerButton;
